export const COURSE_PAUSE_REQUEST_APPROVE_MODAL_STAGES = {
  notOpen: 'notOpen',
  confirm: 'confirm',
  success: 'success',
};
